import React from 'react';

type Size = 'sm' | 'md' | 'lg';

const WIDTH: Record<Size, number> = {
  sm: 168,
  md: 220,
  lg: 260,
};

type Props = {
  src: string;
  alt: string;
  size?: Size;
  className?: string;
};

/** Displays uploaded template preview images at native 9:16 without cropping. */
export const PreviewPhoneFrame: React.FC<Props> = ({ src, alt, size = 'md', className = '' }) => {
  const maxW = WIDTH[size];

  return (
    <div
      className={`dcl-preview-phone ${className}`.trim()}
      style={{ maxWidth: maxW }}
      aria-hidden={alt ? undefined : true}
    >
      <div className="dcl-preview-phone-bezel">
        <div className="dcl-preview-phone-notch" aria-hidden="true" />
        <div className="dcl-preview-phone-screen">
          <img src={src} alt={alt} width={577} height={1024} loading="lazy" decoding="async" />
        </div>
      </div>
    </div>
  );
};

export default PreviewPhoneFrame;
